/* @flow */
/**
 * event.js
 * Written by: Alex Kasemir
 */

import { LIVE_SITE } from 'utils';

/**
 * Description of event
 *
 */
export const event = (name, pData) => {
  if (__CLIENT__) {
    if (LIVE_SITE && window.q_ga) {
      window.q_ga('send', 'event', { // eslint-disable-line
        eventQuiz: name,
        eventAction: `user-event`,
      });
    }

    if (LIVE_SITE && window._paq) { // eslint-disable-line
      if (pData) {
        window._paq.push([`trackEvent`, ...pData]); // eslint-disable-line
      }
    } else {
      console.log([`trackEvent`, ...pData]); // eslint-disable-line
    }
  }
};

export const customVariable = (slot, name, value, scope) => { // eslint-disable-line
  if (__CLIENT__ && window._paq) { // eslint-disable-line
    window._paq.push([`setCustomVariable`, slot, name, value, scope]); // eslint-disable-line
  }
};


export const trackUser = (userId) => {
  if (__CLIENT__ && window._paq) { // eslint-disable-line
    window._paq.push([`setUserId`, userId]); // eslint-disable-line
  }
};

export const resetUserId = () => {
  if (__CLIENT__ && window._paq) { // eslint-disable-line
    window._paq.push([`resetUserId`]); // eslint-disable-line
  }
};

export const trackPageView = () => {
  if (__CLIENT__) {
    window.scrollTo(0, 0);
    if (window.gtag) {
      window.gtag(`config`, `UA-56745337-1`, {
        page_title: document.title,
        page_path: window.location.pathname,
      });
    }

    if (window._paq) { // eslint-disable-line
      _paq.push([`setDocumentTitle`, document.title]); // eslint-disable-line
      _paq.push(['setCustomUrl', window.location.pathname + window.location.search]); // eslint-disable-line
      _paq.push(['trackPageView']); // eslint-disable-line
    }
  }
};

export const trackFacebookConversion = (name, properties) => {
  if (__CLIENT__) {
    if (window.fbq) {
      window.fbq(`track`, name, properties);
    }
  }
};

export const trackGoogleConversion = () => {
  if (__CLIENT__) {
    if (window.gtag) {
      window.gtag_report_conversion();
    }
  }
};

export default event;

